(() => {
  'use strict';
  const t = (text, params) => window.LRSI18n?.t(text, params) ?? String(text).replace(/\{(\w+)\}/g, (match, key) => params && Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match);
  if (window.LRSVehicleNavigation) return;
  const instances = new Map();
  const keys = ['overview','delivery','colors','materials'];
  const labels = {overview:'Overview', delivery:'Delivery', colors:'Colors', materials:'Materials'};
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motion = () => !reducedMotion.matches && document.body?.dataset.lrsMotion !== 'false';
  const cssNumber = (name, fallback = 0) => parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name)) || fallback;

  function init(root = document) {
    const navs = [...root.querySelectorAll('[data-vehicle-navigation]')];
    if (root.matches?.('[data-vehicle-navigation]')) navs.unshift(root);
    navs.forEach(nav => {
      if (instances.has(nav)) return;
      const trigger = nav.previousElementSibling;
      const links = nav.querySelector('[data-vehicle-nav-links]');
      if (!links || !trigger) return;
      const abort = new AbortController();
      const on = (node, event, callback, options = {}) => node.addEventListener(event, callback, {...options, signal:abort.signal});
      let entries = [], active = '', frame = 0, rebuildFrame = 0, revealed = false;
      const scope = nav.closest('main') || document;

      function visible(next) {
        if (revealed === next) return;
        revealed = next;
        nav.classList.toggle('is-visible', next);
        nav.setAttribute('aria-hidden', String(!next));
        nav.inert = !next;
      }
      function ensureInView(link) {
        const bounds = links.getBoundingClientRect(), rect = link.getBoundingClientRect();
        if (rect.left < bounds.left + 4) links.scrollBy?.({left:rect.left - bounds.left - 4, behavior:'auto'});
        else if (rect.right > bounds.right - 4) links.scrollBy?.({left:rect.right - bounds.right + 4, behavior:'auto'});
      }
      function setActive(key) {
        if (active === key) return;
        active = key;
        entries.forEach(entry => {
          if (entry.key === key) entry.link.setAttribute('aria-current','location'); else entry.link.removeAttribute('aria-current');
        });
      }
      function update() {
        frame = 0;
        if (!entries.length) return;
        const headerOffset = cssNumber('--lrs-header-height', 88);
        const navHeight = nav.getBoundingClientRect().height || 50;
        const footer = document.querySelector('footer');
        const pastTitle = trigger.getBoundingClientRect().top <= headerOffset + 2;
        const aboveFooter = !footer || footer.getBoundingClientRect().top > headerOffset + navHeight + 24;
        visible((pastTitle && aboveFooter) || nav.contains(document.activeElement));
        const threshold = headerOffset + navHeight + 80;
        let current = entries[0];
        entries.forEach(entry => {if (entry.target.getBoundingClientRect().top <= threshold) current = entry;});
        setActive(current.key);
      }
      function queue() {if (!frame) frame = requestAnimationFrame(update);}
      function discover() {
        rebuildFrame = 0;
        const candidates = [...scope.querySelectorAll('[data-vehicle-section]')].filter(target => !target.closest('[hidden]'));
        const next = keys.map(key => ({key, target:candidates.find(target => target.dataset.vehicleSection === key)})).filter(entry => entry.target);
        if (next.length === entries.length && next.every((entry, i) => entry.target === entries[i].target)) {queue(); return;}
        entries = next;
        active = '';
        links.replaceChildren();
        entries.forEach(entry => {
          if (!entry.target.id) entry.target.id = `Vehicle-${nav.dataset.vehicleId}-${entry.key}`;
          const link = document.createElement('a');
          link.href = `#${entry.target.id}`;
          link.dataset.vehicleNavKey = entry.key;
          link.textContent = t(labels[entry.key]);
          links.append(link); entry.link = link;
        });
        nav.hidden = entries.length < 2;
        queue();
      }
      function scheduleDiscovery() {if (!rebuildFrame) rebuildFrame = requestAnimationFrame(discover);}
      on(nav, 'click', event => {
        const link = event.target.closest('a[data-vehicle-nav-key]');
        if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (event.button && event.button !== 0)) return;
        const entry = entries.find(item => item.key === link.dataset.vehicleNavKey);
        if (!entry) return;
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('lrs:vehicle-navigation'));
        const offset = cssNumber('--lrs-header-height', 88) + (nav.getBoundingClientRect().height || 50) + 20;
        window.scrollTo({top:Math.max(0, window.scrollY + entry.target.getBoundingClientRect().top - offset), behavior:motion() ? 'smooth' : 'instant'});
        try {history.replaceState(history.state, '', `#${entry.target.id}`);} catch (_) {}
        setActive(entry.key); ensureInView(link);
      });
      on(nav, 'focusin', event => {visible(true); const link=event.target.closest('a'); if (link) ensureInView(link);});
      on(nav, 'focusout', queue);
      on(window, 'scroll', queue, {passive:true});
      on(window, 'resize', queue, {passive:true});
      on(document, 'lrs:headerchange', queue);
      on(document, 'shopify:section:reorder', scheduleDiscovery);
      on(document, 'shopify:section:load', scheduleDiscovery);
      on(document, 'shopify:section:unload', scheduleDiscovery);
      const observer = new MutationObserver(scheduleDiscovery);
      observer.observe(scope === document ? document.body : scope, {childList:true, subtree:true, attributes:true, attributeFilter:['hidden','data-vehicle-section']});
      nav.inert = true;
      nav.setAttribute('aria-hidden','true');
      discover();
      instances.set(nav, () => {
        abort.abort(); cancelAnimationFrame(frame); cancelAnimationFrame(rebuildFrame); observer.disconnect();
        nav.hidden = true; nav.classList.remove('is-visible'); instances.delete(nav);
      });
    });
  }
  window.LRSVehicleNavigation = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => instances.forEach((destroy, nav) => {if (event.target.contains(nav)) destroy();}));
})();
